import React, {useEffect, useState} from 'react';
import './Calendar.css';
import axios from "axios";

const Calendar = ({setDay, currentMonth, currentYear, onPrevMonth, onNextMonth, cort, refreshCalendar}) => {

    const [daysBusy, setDaysBusy] = useState([]);
    // const [addRows, setAddRows] = useState(0);
    let addRows = 0;


    useEffect(() => {
        console.log(refreshCalendar);

        if (cort !== 0) {
            let getCorts;
            axios.get(`/api/get_courts/`, {headers: { 'Content-Type': 'application/json' }, withCredentials: true})
                .then(res => {
                    getCorts = res.data.detail;
                    let cort_id;
                    if (cort===1){
                        cort_id = getCorts[0].id_cort;
                    } else if (cort===2) {
                        cort_id = getCorts[1].id_cort;
                    }

                    axios.get(`/api/booked_times/`, {
                        params: {
                            month: currentMonth + 1,
                            year: currentYear,
                            court_id: cort_id
                        }, withCredentials: true
                    })
                        .then(response => {
                            const busy = response.data.detail;
                            setDaysBusy(busy);
                        })
                        .catch(error => console.error('Error fetching data:', error));
                })
                .catch(e => {
                    // console.log(e);
                })
        }

    }, [currentMonth, currentYear, cort, refreshCalendar]);


    const getMonthName = (monthIndex) => {
        const months = [
            'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
            'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
        ];
        return months[monthIndex];
    };


    const onDayClick = (date) => {
        // setPickedDay(date);
        setDay(date);
    }

    const colorDay = (e) => {
        let allDays = document.getElementsByClassName('ts');
        for (let d of allDays) {
            if (d.classList.contains('selected_day_meeting')) {
                d.classList.remove('selected_day_meeting');
            }
        }
        e.target.classList.add("selected_day_meeting");
    };

    const onChangeMonth = (chngMnth) => {
        chngMnth();
        addRows = 0;
        let allDays = document.getElementsByClassName('ts');
        for (let d of allDays) {
            if (d.classList.contains('selected_day_meeting')) {
                d.classList.remove('selected_day_meeting');
            }
        }
    }

    const renderCalendar = () => {
        const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
        let firstDayOfMonth = (new Date(currentYear, currentMonth, 1).getDay()) - 1;
        if (firstDayOfMonth === -1) {
            firstDayOfMonth = 6;
        }
        let date = 1;
        const rows = [];

        const currentDay = (new Date()).getDate().toString().padStart(2, '0');
        let nowMonth = new Date().getMonth();
        let nowYear = new Date().getFullYear();

        const checkInvalidDay = (day) => {
            if (currentYear < nowYear) {
                return true;
            } else if (currentMonth < nowMonth && currentYear === nowYear) {
                return true;
            } else if (nowMonth === currentMonth && currentYear === nowYear) {
                if (currentDay > day) {
                    return true;
                }
            } else {
                return false;
            }
        }

        for (let i = 0; i < 6; i++) {
            const cells = [];
            for (let j = 0; j < 7; j++) {
                if (i === 0 && j < firstDayOfMonth) {
                    cells.push(<td key={`${i}-${j}`}></td>);
                } else if (date > daysInMonth) {
                    break;
                } else {
                    cells.push(
                        <td key={`${i}-${j}`} className={`day ts ${daysBusy?.includes(date) ? 'has-meeting' : ''} ${checkInvalidDay(date) ? 'unable-day' : ''}`} onClick={(e) => {onDayClick(new Date(currentYear, currentMonth, parseInt(e.target.innerText))); colorDay(e); }}>
                            {date}
                        </td>
                    );
                    date++;
                }
            }
            if (cells.length !== 0) {
                rows.push(<tr key={i}>{cells}</tr>);
            }
        }

        if (rows.length === 4) {
            addRows = 2;
            // rows.push(<div className={'two-row-height'}></div>);
        } else if (rows.length === 5) {
            addRows = 1;
            // rows.push(<div className={'one-row-height'}></div>);
        }

        return rows;
    };


    return (
        <div className={'calendar-and-description'}>
            <p className={'desktop-choose-cort-description-2'}>{`Выберите дату для `}<span className={'desktop-choose-cort-description-3-date-underline'}>{`корта №${cort}`}</span></p>
            <div className={'modal-calendar'}>
                <div className="reserve-month-buttons">
                    <button className={'change-month-button'} onClick={() => onChangeMonth(onPrevMonth)}>{'<'}</button>
                    <p className={'reserve-month'}>{getMonthName(currentMonth)} {currentYear}</p>
                    <button className={'change-month-button'} onClick={() => onChangeMonth(onNextMonth)}>{'>'}</button>
                </div>
                <div id="cl" className="table-responsive">
                    <table className="table table-bordered">
                        <thead>
                        <tr>
                            <th>пн</th>
                            <th>вт</th>
                            <th>ср</th>
                            <th>чт</th>
                            <th>пт</th>
                            <th>сб</th>
                            <th>вс</th>
                        </tr>
                        </thead>
                        <tbody id="cb">
                        {renderCalendar()}
                        </tbody>
                    </table>
                    <div className={`height-of-${addRows}-rows`}></div>
                </div>
            </div>
        </div>
    );
};

export default Calendar;
